import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'reactstrap';
import ResourceProperty from '../../../common/resource/ResourceProperty';
import { tzNormalizeDate } from '../../../../utils/date';
import { DATE_TIME_FORMAT } from '../../../../config/locale';
import { CREDIT_NOTE_MOTIVES } from '../../../../config/constants';

// TODO test
const CreditNote = ({ creditNote, description }) => {
  let noteDescription = creditNote.valid
    ? description
    : 'Nota de crédito ya fue UTILIZADA';
  if (!creditNote.valid && creditNote.amount !== 0)
    noteDescription = 'Nota de crédito ya fue ANULADA';
  const color = creditNote.valid ? 'primary' : 'danger';
  return (
    <Alert color={color}>
      <h3>Nota de crédito</h3>
      <p>{noteDescription}</p>
      {creditNote.documentSeries && creditNote.documentCode && (
        <ResourceProperty label="Serie - Correlativo:">
          {creditNote.documentSeries} -{' '}
          {creditNote.documentCode.toString().padStart(7, '0')}
        </ResourceProperty>
      )}
      <ResourceProperty label="Monto:">
        {!creditNote.valid && creditNote.amount !== 0
          ? '0.00'
          : creditNote.amount.toFixed(2)}
      </ResourceProperty>
      <ResourceProperty label="Fecha de Expiración:">
        {creditNote.expirationDate
          ? tzNormalizeDate({
              date: creditNote.expirationDate,
              format: DATE_TIME_FORMAT,
            })
          : 'No tiene fecha de expiración'}
      </ResourceProperty>
      <ResourceProperty label="Motivo:">
        {CREDIT_NOTE_MOTIVES[creditNote.motive] ? CREDIT_NOTE_MOTIVES[creditNote.motive].label : 'No tiene motivo'}
      </ResourceProperty>
    </Alert>
  );
};

CreditNote.propTypes = {
  creditNote: PropTypes.shape({
    reference: PropTypes.string.isRequired,
    amount: PropTypes.number.isRequired,
    valid: PropTypes.bool.isRequired,
    documentSeries: PropTypes.string.isRequired,
    documentCode: PropTypes.number.isRequired,
    expirationDate: PropTypes.number,
    motive: PropTypes.string,
  }).isRequired,
  description: PropTypes.string,
};

CreditNote.defaultProps = {
  description:
    'Este boleto fue postergado y tiene una nota de crédito disponible',
};

export default CreditNote;
